const formatMonthYear = (date) =>
  date.toLocaleString("en-US", { month: "short", year: "numeric" });

const shiftMonths = (baseDate, monthsBack) =>
  new Date(baseDate.getFullYear(), baseDate.getMonth() - monthsBack, 1);

export function getPeriodLabels(options = {}) {
  const { withMilesSuffix = false } = options;
  const today = new Date();
  const current = new Date(today.getFullYear(), today.getMonth(), 1);

  const currentLabel = formatMonthYear(current);
  const minus12 = formatMonthYear(shiftMonths(current, 12));
  const minus24 = formatMonthYear(shiftMonths(current, 24));
  const minus36 = formatMonthYear(shiftMonths(current, 36));

  const suffix = withMilesSuffix ? " Miles" : "";

  return {
    projected: withMilesSuffix ? "Projected Miles (next 12 months)" : "Projected (next 12 months)",
    current: `${currentLabel} - ${minus12}${suffix}`,
    firstPrior: `${minus12} - ${minus24}${suffix}`,
    secondPrior: `${minus24} - ${minus36}${suffix}`,
  };
}
